const AboutView = () => import('@/modules/statics/views/About')
const ContactView = () => import('@/modules/statics/views/Contact')
const FaqView = () => import('@/modules/statics/views/FAQ')
const ModerationView = () => import('@/modules/statics/views/Moderation')
const PrivacyView = () => import('@/modules/statics/views/Privacy')
const TermsView = () => import('@/modules/statics/views/Terms')
const WalletView = () => import('@/modules/statics/views/Wallet')

export default [
  {
    path: '/faq',
    name: 'statics.faq',
    component: FaqView
  },
  {
    path: '/about',
    name: 'statics.about',
    component: AboutView
  },
  {
    path: '/contact',
    name: 'statics.contact',
    component: ContactView
  },
  {
    path: '/privacy-policy',
    name: 'statics.privacy',
    component: PrivacyView
  },
  {
    path: '/terms-and-conditions',
    name: 'statics.terms',
    component: TermsView
  },
  {
    path: '/moderation-rules',
    name: 'statics.moderation',
    component: ModerationView
  },
  {
    path: '/clubedolivro',
    redirect: to => {
      // the function receives the target route as the argument
      // return redirect path/location here.
      window.location.href = 'https://linktr.ee/Scriv.app'
    }
  },
  {
    path: '/scriv-wallet',
    name: 'statics.wallet',
    component: WalletView
  }
]
